import * as Axios from 'axios';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

export const defaultReqConfig: Axios.AxiosRequestConfig = {
  headers: { 'Content-Type': 'application/json' },
};

const parseApiErrorResponse = (error: Axios.AxiosError) => {
  Logger.error(['API CALL Fail', error, error.response], LogArea.Api);
  return Promise.reject(error);
};

export const get = (
  uri: string,
  reqConfig = defaultReqConfig
): Promise<Axios.AxiosResponse> => {
  return Axios.default.get(uri, reqConfig).catch(parseApiErrorResponse);
};

export const post = (
  uri: string,
  body = {},
  reqConfig = defaultReqConfig
): Promise<Axios.AxiosResponse> => {
  return Axios.default.post(uri, body, reqConfig).catch(parseApiErrorResponse);
};
